import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ORIENTATION_TYPE_OPTION_IDS, IMAGE_TEXT_DROPDOWN_OPTION_IDS } from 'commons/constants';
import { customItem, readyToShipItem, decideLaterItem } from 'components/consumer/PDP/PDPShopTabsBar/itemContent';
import getEnvValue from 'commons/getEnvValue';
import useScreen from 'hooks/useScreen';
import usePdpSelectedCustomizerTab from 'components/consumer/PDP/state/pdpSelectedCustomizerTab/usePdpSelectedCustomizerTab';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import PDPSelectionAlert from './PDPSelectionAlert/PDPSelectionAlert';
import PDPSelectUpholsteryInner from '../PDPSelectUpholstery';
import PDPImageSelector from '../PDPImageSelector';
import PDPImageAndTextSelector from '../PDPImageAndTextSelector';
import PDPTextDropdownOptionGroup from '../PDPTextDropdownOptionGroup';
import PDPImageTextDropdownOption from '../PDPImageTextDropdownOption';
import PDPUpsellProduct from '../PDPUpSellProduct';
import PDPExtraOptionSelector from '../PDPExtraOptionSelector';
import PDPDecideLaterButton from '../PDPDecideLaterButton';
import PDPSelectUpholsteryDecideLater from '../PDPSelectUpholstery/PDPSelectUpholsteryDecideLater';
import PDPSelectUpholsteryPlaceholder, { PDPSelectUpholsteryLayoutRevampPlaceholder } from '../PDPSelectUpholstery/PDPSelectUpholsteryPlaceholder';
import PDPChooseYourOptionsPlaceholder from './PDPChooseYourOptionsPlaceholder';
const getTabContentId = selectedTab => {
  if (selectedTab === customItem.id) {
    return customItem.contentId;
  }
  if (selectedTab === readyToShipItem.id) {
    return readyToShipItem.contentId;
  }
  if (decideLaterItem.id) {
    return decideLaterItem.contentId;
  }
  return '';
};
const IS_PDP_IMAGE_TEXT_DROPDOWN_OPTION_ENABLED = getEnvValue('NEXT_PUBLIC_IS_PDP_IMAGE_TEXT_DROPDOWN_OPTION_ENABLED') === 'true';
const PDPChooseYourOptionsUIInner = t0 => {
  const $ = _c(52);
  const {
    pdpIsModularBYOProduct,
    isDecideLaterTab,
    isEditOrder: t1,
    isFFG: t2,
    isRTSTab: t3,
    loading: t4,
    mode: t5,
    options: t6,
    onMoreMaterialsClick,
    productId: t7,
    selectionValidity: t8,
    slug: t9,
    upholsteryOptionId,
    optionSelector: t10,
    setMarxentSelectedFabric,
    isLayoutRevamp: t11
  } = t0;
  const isEditOrder = t1 === undefined ? false : t1;
  const isFFG = t2 === undefined ? true : t2;
  const isRTSTab = t3 === undefined ? false : t3;
  const loading = t4 === undefined ? false : t4;
  const mode = t5 === undefined ? "pdp" : t5;
  let t12;
  if ($[0] !== t6) {
    t12 = t6 === undefined ? [] : t6;
    $[0] = t6;
    $[1] = t12;
  } else {
    t12 = $[1];
  }
  const options = t12;
  const productId = t7 === undefined ? null : t7;
  const selectionValidity = t8 === undefined ? "" : t8;
  const slug = t9 === undefined ? null : t9;
  const optionSelector = t10 === undefined ? "" : t10;
  const isLayoutRevamp = t11 === undefined ? false : t11;
  const {
    isMobile
  } = useScreen();
  const pdpSelectedCustomizerTab = usePdpSelectedCustomizerTab();
  if (loading) {
    let t13;
    if ($[2] !== pdpSelectedCustomizerTab) {
      t13 = getTabContentId(pdpSelectedCustomizerTab);
      $[2] = pdpSelectedCustomizerTab;
      $[3] = t13;
    } else {
      t13 = $[3];
    }
    const t14 = mode === "pdp";
    let t15;
    if ($[4] !== t14) {
      t15 = classNames("mt-8 mx-0 mb-0 relative w-full last:[border-bottom:0] last:pb-0", {
        "mt-0 mx-0 mb-4": t14
      });
      $[4] = t14;
      $[5] = t15;
    } else {
      t15 = $[5];
    }
    let t16;
    if ($[6] !== isLayoutRevamp || $[7] !== mode) {
      t16 = isLayoutRevamp && mode === "pdp" ? <PDPSelectUpholsteryLayoutRevampPlaceholder /> : <PDPSelectUpholsteryPlaceholder />;
      $[6] = isLayoutRevamp;
      $[7] = mode;
      $[8] = t16;
    } else {
      t16 = $[8];
    }
    let t17;
    if ($[9] !== t15 || $[10] !== t16) {
      t17 = <div className={t15}>{t16}</div>;
      $[9] = t15;
      $[10] = t16;
      $[11] = t17;
    } else {
      t17 = $[11];
    }
    let t18;
    if ($[12] !== t13 || $[13] !== t17) {
      t18 = <div className="flex w-full flex-col relative z-[3]" id={t13}>{t17}</div>;
      $[12] = t13;
      $[13] = t17;
      $[14] = t18;
    } else {
      t18 = $[14];
    }
    return t18;
  }
  let t13;
  if ($[15] !== loading || $[16] !== options || $[17] !== upholsteryOptionId) {
    t13 = !loading && upholsteryOptionId && options?.length ? options.find(opt => opt.id === upholsteryOptionId) : null;
    $[15] = loading;
    $[16] = options;
    $[17] = upholsteryOptionId;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  const upholsteryOptionValue = t13;
  const t14 = optionSelector || "";
  let t15;
  if ($[19] !== t14) {
    t15 = t14.toLowerCase();
    $[19] = t14;
    $[20] = t15;
  } else {
    t15 = $[20];
  }
  const isUpholsterySelectorDropdownMode = t15 === "dropdown";
  const showUpholsterySelector = !!upholsteryOptionValue && !isUpholsterySelectorDropdownMode;
  const isLayoutRevampPdp = isLayoutRevamp && mode === "pdp";
  const isDecideLaterInSelector = isLayoutRevampPdp && showUpholsterySelector;
  let t16;
  if ($[21] !== pdpSelectedCustomizerTab) {
    t16 = getTabContentId(pdpSelectedCustomizerTab);
    $[21] = pdpSelectedCustomizerTab;
    $[22] = t16;
  } else {
    t16 = $[22];
  }
  let t17;
  if ($[23] !== isDecideLaterInSelector || $[24] !== isDecideLaterTab || $[25] !== isEditOrder || $[26] !== isFFG || $[27] !== isLayoutRevamp || $[28] !== isLayoutRevampPdp || $[29] !== isMobile || $[30] !== isUpholsterySelectorDropdownMode || $[31] !== loading || $[32] !== mode || $[33] !== onMoreMaterialsClick || $[34] !== optionSelector || $[35] !== options || $[36] !== pdpIsModularBYOProduct || $[37] !== productId || $[38] !== setMarxentSelectedFabric || $[39] !== showUpholsterySelector || $[40] !== slug || $[41] !== upholsteryOptionId || $[42] !== upholsteryOptionValue) {
    t17 = !loading && options?.length ? <>{isLayoutRevampPdp && !isDecideLaterInSelector && <PDPDecideLaterButton />}{isUpholsterySelectorDropdownMode && <div className={classNames("mt-8 mx-0 mb-0 relative w-full last:[border-bottom:0] last:pb-0", {
        "mt-0 mx-0 mb-4": mode === "quickview",
        "!z-[999]": mode !== "pdp"
      })} key="upholstery-selector-dropdown"><PDPTextDropdownOptionGroup optionId={upholsteryOptionValue?.id} isEditOrder={isEditOrder} slug={slug} /></div>}{isDecideLaterTab && !isUpholsterySelectorDropdownMode && !isDecideLaterInSelector ? !isLayoutRevampPdp && !isMobile && <PDPSelectUpholsteryDecideLater /> : showUpholsterySelector ? <div className={classNames("mx-0 mb-0 relative w-full last:[border-bottom:0] last:pb-0", "PDPChooseYourOptionsUI__section--select-upholstery-wrapper", {
        "mt-8": !isLayoutRevampPdp,
        "mt-4": isLayoutRevampPdp,
        "mt-0 mx-0 mb-4": mode === "quickview"
      })} key={upholsteryOptionValue.id} data-xc="MaterialThumbnailGroup"><PDPSelectUpholsteryInner isEditOrder={isEditOrder} mode={mode} optionId={upholsteryOptionValue.id} onMoreMaterialsClick={onMoreMaterialsClick} productId={productId} slug={slug} setMarxentSelectedFabric={setMarxentSelectedFabric} isLayoutRevamp={isLayoutRevamp} /></div> : <div className="PDPChooseYourOptionsUI__section--select-upholstery-wrapper-filler" />}<div className="PDPChooseYourOptionsUI__option-sections-wrapper">{options.map(option => {
          if (isFFG && option.id === 19 || option.id === upholsteryOptionId || pdpIsModularBYOProduct && ORIENTATION_TYPE_OPTION_IDS.includes(option.id) || (option.id !== 17 || option.id !== 18) && isEditOrder) {
            return null;
          }
          if ((IS_PDP_IMAGE_TEXT_DROPDOWN_OPTION_ENABLED || isLayoutRevamp && mode === "pdp") && IMAGE_TEXT_DROPDOWN_OPTION_IDS.includes(option.id)) {
            return <div className={classNames("mt-8 mx-0 mb-0 relative w-full last:[border-bottom:0] last:pb-0", {
              "mt-0 mx-0 mb-4": mode === "quickview",
              "!z-[999]": mode !== "pdp"
            })} key={option.id}><PDPImageTextDropdownOption optionId={option.id} /></div>;
          }
          if ((optionSelector || "").toLowerCase() === "dropdown") {
            return <div className={classNames("mt-8 mx-0 mb-0 relative w-full last:[border-bottom:0] last:pb-0", {
              "mt-0 mx-0 mb-4": mode === "quickview",
              "!z-[999]": mode !== "pdp"
            })} key={option.id}><PDPTextDropdownOptionGroup optionId={option.id} /></div>;
          }
          switch (option.optionDisplayType) {
            case "ImageSelector":
              {
                return <div className={classNames("mt-8 mx-0 mb-0 relative w-full last:[border-bottom:0] last:pb-0", {
                  "mt-0 mx-0 mb-4": mode === "pdp"
                })} key={option.id}><PDPImageSelector isEditOrder={isEditOrder} optionId={option.id} /></div>;
              }
            case "TextSelector":
            case "ImageAndTextSelector":
              {
                return <div className={classNames("mt-8 mx-0 mb-0 relative w-full last:[border-bottom:0] last:pb-0", {
                  "mt-0 mx-0 mb-4": mode === "pdp"
                })} key={option.id}><PDPImageAndTextSelector isEditOrder={isEditOrder} imageOrTextVariant={option.optionDisplayType === "TextSelector" ? "textOnly" : "regular"} mode={mode} optionId={option.id} productId={productId} variant="regular" /></div>;
              }
            case "PDPFullWidthImageAndTextSelector":
              {
                return <div className={classNames("mt-8 mx-0 mb-0 relative w-full last:[border-bottom:0] last:pb-0", {
                  "mt-0 mx-0 mb-4": mode === "pdp"
                })} key={option.id}><PDPImageAndTextSelector isEditOrder={isEditOrder} optionId={option.id} productId={productId} variant="fullWidth" /></div>;
              }
            case "TextDropdownSelector":
              {
                return <div className={classNames("mt-8 mx-0 mb-0 relative w-full last:[border-bottom:0] last:pb-0", {
                  "mt-0 mx-0 mb-4": mode === "quickview",
                  "!z-[999]": mode !== "pdp"
                })} key={option.id}><PDPTextDropdownOptionGroup key={`${option.id}--PDPTextDropdownOptionGroup`} optionId={option.id} /></div>;
              }
            case "UpsellSelector":
              {
                return <PDPUpsellProduct productId={productId} slug={slug} />;
              }
            case "ExtraOptionSelector":
              {
                return <PDPExtraOptionSelector key={`${option.id}--PDPExtraOptionSelector`} />;
              }
            default:
              {
                return <div className={classNames("mt-8 mx-0 mb-0 relative w-full last:[border-bottom:0] last:pb-0", {
                  "mt-0 mx-0 mb-4": mode === "quickview"
                })} key={option.id}><PDPTextDropdownOptionGroup optionId={option.id} /></div>;
              }
          }
        })}</div></> : <><div className="PDPChooseYourOptionsUI__PDPSelectUpholsteryDecideLater-filler" /><div className="PDPChooseYourOptionsUI__PDPSelectUpholsteryDecideLater-filler" /></>;
    $[23] = isDecideLaterInSelector;
    $[24] = isDecideLaterTab;
    $[25] = isEditOrder;
    $[26] = isFFG;
    $[27] = isLayoutRevamp;
    $[28] = isLayoutRevampPdp;
    $[29] = isMobile;
    $[30] = isUpholsterySelectorDropdownMode;
    $[31] = loading;
    $[32] = mode;
    $[33] = onMoreMaterialsClick;
    $[34] = optionSelector;
    $[35] = options;
    $[36] = pdpIsModularBYOProduct;
    $[37] = productId;
    $[38] = setMarxentSelectedFabric;
    $[39] = showUpholsterySelector;
    $[40] = slug;
    $[41] = upholsteryOptionId;
    $[42] = upholsteryOptionValue;
    $[43] = t17;
  } else {
    t17 = $[43];
  }
  let t18;
  if ($[44] !== isRTSTab || $[45] !== loading || $[46] !== selectionValidity) {
    t18 = !loading && isRTSTab && selectionValidity ? <PDPSelectionAlert selectionValidity={selectionValidity} /> : <div className="PDPChooseYourOptionsUI__PDPSelectionAlert-filler" />;
    $[44] = isRTSTab;
    $[45] = loading;
    $[46] = selectionValidity;
    $[47] = t18;
  } else {
    t18 = $[47];
  }
  let t19;
  if ($[48] !== t16 || $[49] !== t17 || $[50] !== t18) {
    t19 = <div className="flex w-full flex-col relative z-[3]" id={t16}>{t17}{t18}</div>;
    $[48] = t16;
    $[49] = t17;
    $[50] = t18;
    $[51] = t19;
  } else {
    t19 = $[51];
  }
  return t19;
};
PDPChooseYourOptionsUIInner.propTypes = {
  isDecideLaterTab: PropTypes.bool,
  isEditOrder: PropTypes.bool,
  isFFG: PropTypes.bool,
  isRTSTab: PropTypes.bool,
  loading: PropTypes.bool,
  mode: PropTypes.oneOf(['pdp', 'quickview']),
  onMoreMaterialsClick: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.object),
  optionSelector: PropTypes.string,
  pdpIsModularBYOProduct: PropTypes.bool,
  productId: PropTypes.number,
  selectionValidity: PropTypes.string,
  setMarxentSelectedFabric: PropTypes.func,
  slug: PropTypes.string,
  upholsteryOptionId: PropTypes.number,
  isLayoutRevamp: PropTypes.bool
};
const PDPChooseYourOptionsUI = props => {
  const $ = _c(8);
  let t0;
  if ($[0] !== props.isLayoutRevamp || $[1] !== props.mode) {
    t0 = props.isLayoutRevamp && (props.mode ?? "pdp") === "pdp" ? <PDPSelectUpholsteryLayoutRevampPlaceholder /> : <PDPChooseYourOptionsPlaceholder />;
    $[0] = props.isLayoutRevamp;
    $[1] = props.mode;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== props) {
    t1 = <PDPChooseYourOptionsUIInner {...props} />;
    $[3] = props;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t0 || $[6] !== t1) {
    t2 = <SuspenseWithLoader fallback={t0}>{t1}</SuspenseWithLoader>;
    $[5] = t0;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
export default PDPChooseYourOptionsUI;